import { useEffect } from 'react';

import './css/tcm.scss';
import { Outlet } from 'react-router-dom';
import { ROUTE_TCM_PROJECTS } from './Routes/Routes';

const TcmContainer = () => {
  let pageTitle = ROUTE_TCM_PROJECTS.title;

  useEffect(() => {
    const title = ROUTE_TCM_PROJECTS.title;
    document.title = title;
  }, []);
  return (
    <>
      <h1>{pageTitle}</h1>
      <Outlet />
    </>

  );
}
export default TcmContainer;

